import * as Sentry from '@sentry/react';

const trackUserAction = (actionDescription: string) => {
  Sentry.addBreadcrumb({
    category: 'user.action',
    message: actionDescription,
    level: 'info',
    timestamp: new Date().getTime()
  });
};

export default trackUserAction;
